import {StandardFileActions} from 'app/services/standard-file-actions';
import {STANDARD_FILE_METADATA} from 'app/models/standard-files.model';
import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {Standard} from 'app/models/standard.model';
import {standardResponseWithVersion} from 'app/services/standard-version';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {AdminService} from '../../../../services/admin.service';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../../../services/user.service';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../../services/view-docx.service';

@Component({
  selector: 'app-steps-files',
  templateUrl: './steps-files.component.html',
  styleUrls: ['./steps-files.component.css']
})
export class StepsFilesComponent implements OnInit, OnDestroy {
  @Input() blocked = false;
  fileActions = new StandardFileActions(this.adminService, this.modalService);

  // Standard
  thisStandard: any;

  isLoaded = true;
  isUploadDisabled = false;
  fileReloadFailed = false;
  fileReloadPending = false;
  private filesDestroyed$ = new Subject<void>();
  newRuName = '';
  newEnName = '';
  newRuAn = '';
  newEnAn = '';
  formData: FormData = new FormData();

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  constructor(private adminService: AdminService,
              private apiConnectService: ApiConnectService,
              private modalService: NgbModal,
              private userService: UserService,
              public viewDocxService: ViewDocxService,
              public stepsControllerService: StepsControllerService) {
  }

  ngOnInit() {
    // Get standard
    if (this.stepsControllerService.getCurrentStandard()) {
      this.thisStandard = this.stepsControllerService.getCurrentStandard();

    } else {
      this.thisStandard = null;
    }
    // Set file names
    if (this.thisStandard) {
      this.newRuName = this.thisStandard.ruName;
      this.newEnName = this.thisStandard.enName;
      this.newRuAn = this.thisStandard.ruAnnotation;
      this.newEnAn = this.thisStandard.enAnnotation;
    }

  }

  uploadFile(type: string): void {
    if (this.blocked || this.fileReloadPending) { return; }
    const fields = STANDARD_FILE_METADATA[type];
    if (!fields) { return; }
    this.fileActions.upload(this.thisStandard, {type: type, file: this[fields.draft]}, () => this.acceptFileUpload(type));
  }

  private acceptFileUpload(type: string): void {
    const fields = STANDARD_FILE_METADATA[type];
    this[fields.draft] = null;
    this[fields.selected] = false;
    this.stepsControllerService.showByFilesAndBlanks = true;
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string): void {
    if (this.blocked || this.fileReloadPending) { return; }
    this.fileActions.remove(this.thisStandard, {type: type, fileId: fileId}, () => this.acceptFileRemoval());
  }

  private acceptFileRemoval(): void {
    this.stepsControllerService.showByFilesAndBlanks = true;
  }

  fileChange(typeFile, event) {
    if (typeFile === 'RU_PPT') {
      if (event.target.files.length > 0) {
        this.fileRuPpt = event.target.files[0];
        this.isNewRuPpt = true;
      } else {
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    }

    if (typeFile === 'RU_DOC') {
      if (event.target.files.length > 0) {
        this.fileRuDoc = event.target.files[0];
        this.isNewRuDoc = true;
      } else {
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    }

    if (typeFile === 'RU_PDF') {
      if (event.target.files.length > 0) {
        this.fileRuPdf = event.target.files[0];
        this.isNewRuPdf = true;
      } else {
        this.fileRuPdf = null;
        this.isNewRuPdf = false;
      }
    }

    if (typeFile === 'EN_PPT') {
      if (event.target.files.length > 0) {
        this.fileEnPpt = event.target.files[0];
        this.isNewEnPpt = true;
      } else {
        this.fileEnPpt = null;
        this.isNewEnPpt = false;
      }
    }
    if (typeFile === 'EN_DOC') {
      if (event.target.files.length > 0) {
        this.fileEnDoc = event.target.files[0];
        this.isNewEnDoc = true;
      } else {
        this.fileEnDoc = null;
        this.isNewEnDoc = false;
      }
    }
    if (typeFile === 'EN_PDF') {
      if (event.target.files.length > 0) {
        this.fileEnPdf = event.target.files[0];
        this.isNewEnPdf = true;
      } else {
        this.fileEnPdf = null;
        this.isNewEnPdf = false;
      }
    }
  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  deleteFileDOCX(fileLink: string, type: string, fileId: string): void {
    if (this.blocked || this.fileReloadPending) { return; }
    this.fileActions.remove(this.thisStandard, {type: type, fileId: fileId, link: fileLink}, () => this.acceptFileRemoval());
  }

  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });
  }

  ngOnDestroy(): void {
    this.fileActions.ngOnDestroy();
    this.filesDestroyed$.next();
    this.filesDestroyed$.complete();
  }

  reloadStandardFiles(): void {
    if (this.blocked || this.fileActions.pending || this.fileReloadPending) { return; }
    this.fileReloadPending = true;
    this.fileReloadFailed = false;
    this.adminService.getStandard(this.thisStandard.id).takeUntil(this.filesDestroyed$).subscribe(
      (response: HttpResponse<Standard>) => {
        this.fileReloadPending = false;
        const standard = standardResponseWithVersion(response).body;
        if (!standard || standard.id !== this.thisStandard.id) { this.fileReloadFailed = true; return; }
        this.fileActions.reset();
        this.stepsControllerService.setCurrentStandard(standard);
      }, () => { this.fileReloadPending = false; this.fileReloadFailed = true; }
    );
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/steps-files/steps-files.component.ts